import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

/*
Monolit.Personal:MatHelpType:MatHelpType_ListRefPO;
Monolit.Personal:MatHelp:MatHelp_ListAllForPO;
 */

export function matHelpReducer() {
    return combineReducers({
        MatHelpType_ListRefPO: createItemReducer("MatHelp", "MatHelpType.ListRefPO", false),
        MatHelp_ListAllForPO: createItemReducer("MatHelp", "MatHelp.ListAllForNewPO", false),
        MatHelp_CreateFromPO_Marriage: createItemReducer("MatHelp", "MatHelp.CreateFromNewPO_Marriage", false),
        MatHelp_CreateFromPO_Marriage_Params: createItemReducerParams("MatHelp", "MatHelp.CreateFromNewPO_Marriage"),
        MatHelp_CreateFromPO_Child: createItemReducer("MatHelp", "MatHelp.CreateFromNewPO_Child", false),
        MatHelp_CreateFromPO_Child_Params: createItemReducerParams("MatHelp", "MatHelp.CreateFromNewPO_Child"),
        MatHelp_CreateFromPO_Burial: createItemReducer("MatHelp", "MatHelp.CreateFromNewPO_Burial", false),
        MatHelp_CreateFromPO_Burial_Params: createItemReducerParams("MatHelp", "MatHelp.CreateFromNewPO_Burial"),
        MatHelp_CreateFromPO_SemiCent: createItemReducer("MatHelp", "MatHelp.CreateFromNewPO_SemiCent", false),
        MatHelp_CreateFromPO_SemiCent_Params: createItemReducerParams("MatHelp", "MatHelp.CreateFromNewPO_SemiCent"),
    });
}